module.exports = __webpack_public_path__ + "img/2025special_01.858c628c.jpg";